module.exports = __webpack_public_path__ + "img/icon-copy.d8346777.svg";